import classNames from "classnames";
import React, { memo } from "react";
import Styled from "./rotatedArrow.styled";
import { NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME } from "Areas/Sidebar/Common/constants";
function RotatedArrow({ rotate = 0, defaultRotate = -90, size = 16, open = false, useTriangle = false, ...props }) {
    return (React.createElement(Styled.RotatedArrow, { size: size, className: classNames(props.className, useTriangle ? "dx-icon-spinup" : "icon-arrow-up", "text-light-on-surface-variant", NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME, open && "open"), onClick: props.onClick, rotate: rotate, defaultRotate: defaultRotate }));
}
export default memo(RotatedArrow);
